import { styled } from "@mui/material";
import { MaterialDesignContent } from "notistack";

import { IconButton } from "@citrine/atoms/icon-button";

export const CloseButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.common.white,
}));

export const StyledContent = styled(MaterialDesignContent)(({ theme }) => ({
  "&&": {
    alignItems: "flex-start", // close button is top-aligned
    backgroundColor: theme.palette.grey[900],
    padding: theme.spacing(1, 2),

    "& #notistack-snackbar": {
      alignSelf: "stretch", // override "flex-start" above
      padding: 0,

      "& > svg": {
        alignSelf: "flex-start", // icon is top-aligned
        color: theme.palette.common.white, // this is already the default, but ensure custom icons do not override
        margin: theme.spacing(0.25, 1, 0.25, 0),
      },
    },
  },
}));
